<div class="two-factor">
  <ng-container *ngIf="!twoFactorEnabled">
    <p i18n>Two factor authentication adds an additional layer of security to your account by requiring a numeric code from another device (most commonly mobile phones) when you log in.</p>

    <my-button [ptRouterLink]="[ '/my-account/two-factor-auth' ]" className="orange-button-link" i18n>Enable two-factor authentication</my-button>
  </ng-container>

  <ng-container *ngIf="twoFactorEnabled">
    <my-button className="orange-button" (click)="disableTwoFactor()" i18n>Disable two-factor authentication</my-button>
  </ng-container>

</div>
